import { useQuery, useSuspenseQuery } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import { documentWithDownloadUrlSchema } from '../../../common/validations/documentWithDownloadUrl'
import { ResidentAppError } from '../../../common/error'

import { get } from 'api/apiClient'

const params = (uuid: string, documentUuid: string) => ({
  queryKey: [`${API_ENDPOINTS.CONTRACTS}/${uuid}/documents/${documentUuid}`],
  queryFn: () =>
    get(
      `${API_ENDPOINTS.CONTRACTS}/${uuid}/documents/${documentUuid}`,
      documentWithDownloadUrlSchema
    ),
  enabled: false, // don't fetch by default
})

export const useAPIGetContractDocument = (
  contractUUID: string,
  documentUuid: string
) =>
  useQuery({
    ...params(contractUUID, documentUuid),
    throwOnError() {
      throw ResidentAppError.ClientError('FILE_FAILED_TO_OPEN')
    },
  })

export const useAPIGetContractDocumentSuspense = (
  contractUUID: string,
  documentUuid: string
) =>
  useSuspenseQuery({
    ...params(contractUUID, documentUuid),
  })
